import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FilterGroupType, RuleOperator, FilterGroup, Filter } from 'src/app/modules/core/store/models/filters.model';
import { DocumentSchema, FieldDataType, SchemaField } from 'src/app/modules/core/store/models/document.model';
import { Workflow } from 'src/app/modules/core/store/models/workflow.model';
import { v4 as uuidv4 } from 'uuid';
import { Store } from '@ngrx/store';
import produce from 'immer';
import * as fromUserProfile from 'src/app/modules/core/store/user-profile';
import { filter, take } from 'rxjs/operators';

@Component({
    selector: 'topo-filter-group',
    templateUrl: './filter-group.component.html',
    styleUrls: ['./filter-group.component.scss'],
    standalone: false
})
export class FilterGroupComponent implements OnInit {
  @Input() set filterGroup(value: FilterGroup) {
    if (!value) {
      this._filterGroup = null;
      return;
    }

    if (!value.uId) {
       value.uId = uuidv4();
    }

    for (let filter of value?.filters) {
      if (!filter.uId) {
        filter.uId = uuidv4();
      }
    }

    if (value?.filters?.length === 0) {
      value.filters.push({
        uId: uuidv4(),
        field: null,
        operator: RuleOperator.Equal,
        value: null,
        options: null,
        displayValue: null,
        dataType: null
      });
    }

    for (const filterGroup of value?.filterGroups) {
      if (!filterGroup.uId) {
        filterGroup.uId = uuidv4();
      }
    }

    this._filterGroup = value;
  }
  _filterGroup: FilterGroup;
  @Input() parentFilterGroup: FilterGroup;
  @Input() level: number;
  @Input() schema: DocumentSchema = {
    fields: []
  };
  @Input() workflow: Workflow;
  @Input() lookupTargetSchemaFields: SchemaField[];
  @Input() useForDatamart: boolean;
  @Output() enableSaveFilterbuttonEvent = new EventEmitter<Boolean>();
  nextLevel: number;
  spaces: number[];
  unitsConversionValue: number;
  public SchemaDataType = FieldDataType;

  constructor(private store: Store<fromUserProfile.State>) {}

  ngOnInit(): void {
    this.store
      .select(fromUserProfile.selectDistanceUnit)
      .pipe(take(1))
      .subscribe(unit => {
        if (unit?.toLocaleLowerCase() === 'miles') {
          this.unitsConversionValue = 1609;
        } else {
          this.unitsConversionValue = 1000;
        }
      });

    this.nextLevel = this.level + 1;
    this.spaces = Array(this.level)
      .fill(1)
      .map((x, i) => i);
  }

  enableSaveFilterbutton(buttonDisabled) {
    this.enableSaveFilterbuttonEvent.emit(buttonDisabled);
  }

  addFilterClick(): void {
    this._filterGroup.filters.push({
      uId: uuidv4(),
      field: null,
      operator: RuleOperator.Equal,
      value: null,
      options: null
    });
  }

  addFilterGroupClick(): void {
    this._filterGroup.filterGroups.push({
      uId: uuidv4(),
      filters: [],
      filterGroups: [],
      groupType: FilterGroupType.And
    });
  }

  addFilterGroupToParentClick(): void {
    if (!this.parentFilterGroup) {
      return;
    }

    this.parentFilterGroup.filterGroups.push({
      uId: uuidv4(),
      filters: [],
      filterGroups: [],
      groupType: FilterGroupType.And
    });
  }

  deleteFilterGroupClick(): void {
    if (!this.parentFilterGroup) {
      return;
    }

    const index = this.parentFilterGroup.filterGroups.indexOf(this._filterGroup);
    this.parentFilterGroup.filterGroups.splice(index, 1);
  }

  filterTrack(index, item: Filter) {
    return item.uId;
  }

  filterGroupTrack(index, item: FilterGroup) {
    return item.uId;
  }
}
